export enum ValidatorRegex {
  ALPHABET = '^[a-zA-Z ]+$',
  EMAIL = '^\\S+@\\S+\.\\S+$',
  PHONENUMBER = '^\\d{11,12}$',
}
